import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { proCityList } from '../js/district.js';
export default {
  name: 'yujipointlist',
  props: {
    formoption: {
      type: Object,
      default: {}
    },
    datalist: {
      type: Array,
      default: []
    },
    modeltype: {
      type: Number,
      default: 0
    },
    style: {
      type: Object,
      default: {}
    },
    listshowflag: {
      type: Number,
      default: 1
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    formlabel: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      heightdata: false,
      List: [],
      defaultdataList: [],
      formObj: {},
      listStyle: {},
      upFlag: false,
      districtList: [],
      markerIndex: '',
      loading: true
    };
  },
  watch: {
    datalist: {
      handler(val) {
        this.List = [...val];
        this.defaultdataList = [...val];
        this.loading = false;
      },
      deep: true
    },
    style: {
      handler(val) {
        this.listStyle = {
          ...val
        };
        delete this.listStyle.width;
      },
      deep: true
    }
  },
  mounted() {
    // console.log(proCityList)
    this.districtList = proCityList.map(item => {
      let province = {
        title: item.name
      };
      return province;
    });
  },
  methods: {
    gosearch() {
      let filters = {};
      Object.keys(this.formObj).forEach(item => {
        filters[item] = this.formObj[item] === '' ? [] : this.formObj[item].toString().split(',');
      });
      let cacheData = JSON.parse(JSON.stringify(this.defaultdataList));
      let filterArray = this.multiFilter(cacheData, filters);
      let data = JSON.parse(JSON.stringify(filterArray));
      this.List = data.map(item => {
        item.itemformdata.title = item.itemformdata.title.replace(/\ufe35/g, '\uff08');
        item.itemformdata.title = item.itemformdata.title.replace(/\ufe36/g, '\uff09');
        return item;
      });
    },
    // 静态数据筛选
    multiFilter(array, filters) {
      const filterKeys = Object.keys(filters);
      return array.filter(item => {
        let itemflag = filterKeys.every(key => {
          // 自定义判断
          if (key === 'title') {
            return !!~item.itemformdata[key].indexOf(filters[key]);
          }
          if (!filters[key].length) return true;
          return !!~filters[key].indexOf(item.itemformdata[key]);
        });
        return itemflag;
      });
    },
    listmarkerclick(item, index) {
      this.markerIndex = index;
      this.$emit('listclick', item);
    },
    listUp() {
      this.upFlag = !this.upFlag;
      this.$emit('listup', this.upFlag);
    },
    listDown() {
      this.upFlag = false;
    },
    resetMarkerIndex() {
      this.markerIndex = '';
    }
  }
};